import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import { useSelector } from "react-redux";
import ButtonContained from "../button";
import DropdownComp from '../dropdown';
import FleUpload from "../fileUpload/FleUpload";
import { AddBulkUploadSchema } from "../../validation/ValidationSchema";
import { getBase64 } from "../../utils/converter";
import { api } from '../../api';
import { toast } from "react-toastify";
import Loader from "../loader/Loader";

const BulkUpload = () => {

  const token = useSelector((state) => state.auth.token);
  // eslint-disable-next-line
  const { userType: role } = useSelector((state) => state.auth.user);

// eslint-disable-next-line no-unused-vars
  const [apiAccess, setApiAccess] = useState(false);
  const [productDataList, setProductDataList] = useState([
    { value: "", label: "please select" },
  ]);

  // eslint-disable-next-line no-unused-vars
  const [data, setData] = useState({});
  const [masterDataList, setMasterDataList] = useState([
    { value: "", label: "please select" },
  ]);
  const masterList = masterDataList.length
    ? masterDataList
    : [{ value: "", label: "please select" }];

  const masterOptions = masterList;



    useEffect(() => {
      const fetchMasterData = async () => {
        try {
          const res = await api.products.getMasterData({}, token);
          if (res.code === 200) {
            const masterList = res.data.result.map(i => ({
              value: i.masterProdId,
              label: i.masterProdName,
            }));
            setMasterDataList(masterList);
          }else{
            setMasterDataList([]);
          }
        } catch (error) {
          setMasterDataList([]);
          console.error("Failed to fetch master data:", error);
        }
      };

      fetchMasterData();
    }, [token]);
// eslint-disable-next-line no-unused-vars
  const getFiles1 = (files) => {
    setData(files);
  };
// eslint-disable-next-line no-unused-vars
  const checkApiAccess = (e) => {
    setApiAccess(e.target.checked);
  };

  const productList = productDataList.length
    ? productDataList
    : [{ value: "", label: "please select" }];
  // eslint-disable-next-line no-unused-vars
  const options = productList;

  //loading
  const [isLoading, setIsLoading] = useState(false);

  //
  const handleFileChange = (name, e, setFieldValue) => {
    setFieldValue(name, e.currentTarget.files[0]);
    getBase64(e.currentTarget.files[0], (res) => {
      setFieldValue(`${name}Base64`, res);
    });
  };

  useEffect(() => {
    api.products.getProducts({},token).then((res) => {
      var productList = [];
      if (res.code === 200) {
        for (let i of res.data.result) {
          productList.push({ value: i.productId, label: i.productName });
        }
        setProductDataList(productList);
      }else{
        setProductDataList([]);
      }
    });
  }, [token]);
  const labelLink=(
    <>
   Product Key <a download="sample.xlsx" href="resource\sample.xlsx" target="_blank" style={{ color: '#5C2E91', letterSpacing: '0.2px', fontWeight: 'bolder'}}>
(Sample.xlsx)</a>
   </>
  )
  

  return (
    <Formik
      validationSchema={AddBulkUploadSchema}
      initialValues={{
        // productBrand: '',
        master: "",
        batchNumber: "",
        ProductKey: "",
        ProductKeyBase64: "",
      }}
      onSubmit={(values, { resetForm }) => {
        setIsLoading(true);
        const formBody = {
          fileData: values.ProductKeyBase64.fileData,
          fileType: values.ProductKeyBase64.fileType,
          // productId: values.productBrand.value,
          masterProductId: values.master.value,
          // batchNo: values.batchNumber,
        };
        api.products
          .uploadProductKeys(formBody,token)
          .then((res) => {
            if (res.code === 200) {
              resetForm();
              setIsLoading(false);
              toast.success(`In ${res.data.total} uploaded keys, ${res.data.stock} keys ${res.message} uploaded. ${res.data.duplicate} keys already exists. `);
              // history.push('/products')
            } else if( res.code === 403) {
              resetForm();
              setIsLoading(false);
               toast.info(`In ${res.data.totalData} uploaded keys, ${res.data.existsData} keys already exists, so could not upload the keys. Please try again with unique keys`);
            }
          })
          .catch((err) => {
            resetForm();
            setIsLoading(false);
            toast.error("!Oops, Something went wrong");
          });
      }}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
        isSubmitting,
        setFieldValue,
      }) => {
        return (
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12">
                <div className="box-row">
                  <div className="table-head">
                    <h1 className="sec-header">BULK UPLOAD</h1>
                  </div>
                  <div className="card card-table">
                    {/* <div className="card-header card-header-title">
                      {" "}
                      Products Details
                    </div> */}
                    <div className="card-body gatepass-saveoutput">
                      <div className="reports">
                        <Form onSubmit={handleSubmit}>
                          <div className="form-row">
                            <div className="form-group col-md-4">
                              {/* <DropdownComp
                                                                id="productBrand"
                                                                name="productBrand"
                                                                onChange={(selectedValue) => {
                                                                    console.log(selectedValue)
                                                                    setFieldValue("productBrand", selectedValue)
                                                                    console.log(values)
                                                                }}
                                                                value={values.productBrand}
                                                                options={options}
                                                                label="Products"
                                                                placeholder="Products"
                                                                error={touched.productBrand && errors.productBrand}
                                                                errorText={errors.productBrand}
                                                                disabled={isSubmitting} /> */}

                              <DropdownComp
                                id="master"
                                name="master"
                                placeholder="Master product"
                                label="Master Product"
                                value={values.master}
                                // isMulti
                                onChange={(selectedValue) => {
                                  console.log(selectedValue)
                                  setFieldValue("master", selectedValue);
                                }}
                                options={masterOptions}
                                error={touched.master && errors.master}
                                errorText={errors.master}
                                disabled={isSubmitting}
                              />
                            </div>

                            {/* <div className="form-group col-md-4">
                              <Input
                                id="batchNumber"
                                name="batchNumber"
                                placeholder="Batch Number"
                                type="number"
                                label="Batch Number"
                                value={values.batchNumber}
                                onChange={handleChange}
                                error={
                                  touched.batchNumber && errors.batchNumber
                                }
                                errorText={errors.batchNumber}
                                disabled={isSubmitting}
                              />
                            </div> */}
                          </div>

                          <div className="form-row">
                            <div className="form-group col-md-4">
                              <FleUpload
                                changeFileAlign={true}
                                onClick={(e)=>e.currentTarget.value = null}
                                onChange={(e) => {
                                  handleFileChange(
                                    "ProductKey",
                                    e,
                                    setFieldValue
                                  );
                                }}
                                name="ProductKey"
                                value={
                                  values.ProductKey && values.ProductKey.name
                                }
                                labelText={labelLink}
                                id="ProductKey"
                                error={touched.ProductKey && errors.ProductKey}
                                errorText={errors.ProductKey}
                                disabled={isSubmitting}
                              />
                            </div>
                          </div>

                          <ButtonContained
                            buttonName="Upload"
                            disabled={isSubmitting}
                            loading={isLoading}
                          >
                            <Loader />
                          </ButtonContained>
                        </Form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      }}
    </Formik>
  );
};

export default BulkUpload;
